import { AbsoluteRouteContextType } from './context';

export const handleScreenStateChange =
  (setCurrentRoutes: AbsoluteRouteContextType['setCurrentRoutes']) =>
  ({ data: eventData }) => {
    if (eventData.state?.routes?.length) {
      setCurrentRoutes(eventData.state?.routes);
    }
  };

export const handleScreenFocusChange =
  (setCurrentRoute: AbsoluteRouteContextType['setCurrentRoute']) => (props: any) => {
    setCurrentRoute(props.target);
  };
